import { computeRef, ensureReference, } from "@knyt/artisan";
import { HostMonitor } from "./HostMonitor.js";
import { track } from "./tracking.js";
/**
 * @remarks
 *
 * This controller should be added before the host is connected.
 */
export class ResizeObserverController {
    #host;
    #hostMonitor;
    #disabled = false;
    #onResize;
    #target$;
    #resizeObserver$;
    #targetWithResizeObserver$;
    constructor(host, { disabled, onResize, target }) {
        this.#disabled = disabled ?? false;
        this.#host = host;
        this.#onResize = onResize;
        this.#target$ = ensureReference(target);
        this.#hostMonitor = new HostMonitor(host);
        this.#resizeObserver$ = computeRef({
            dependencies: [this.#target$, this.#hostMonitor.isHostConnected$],
            compute: (target, isHostConnected) => {
                if (!isHostConnected)
                    return null;
                const ResizeObserverConstructor = target?.ownerDocument.defaultView?.ResizeObserver;
                if (!ResizeObserverConstructor)
                    return null;
                return new ResizeObserverConstructor(this.#handleResize);
            },
            onUpdate: (_currentValue, previousValue) => {
                if (previousValue) {
                    previousValue.disconnect();
                }
            },
        });
        this.#targetWithResizeObserver$ = computeRef({
            dependencies: [this.#target$, this.#resizeObserver$],
            compute: (target, resizeObserver) => {
                if (!target || !resizeObserver) {
                    return undefined;
                }
                return [target, resizeObserver];
            },
            onUpdate: (currentParams, previousParams) => {
                if (previousParams) {
                    const [target, resizeObserver] = previousParams;
                    resizeObserver.unobserve(target);
                }
                if (currentParams) {
                    const [target, resizeObserver] = currentParams;
                    resizeObserver.observe(target);
                }
            },
        });
        track(host, this.#targetWithResizeObserver$);
        host.addController(this);
    }
    hostConnected;
    #handleResize = (...args) => {
        if (this.#disabled)
            return;
        this.#onResize?.(...args);
    };
}
